<template>
  <div class="row">
    <div class="col-sm-12 col-md">
      <div class="form-group">
        <label for="company">Entreprise</label>
        <select name="company" v-model="selectedCompany" @change="onSelectChange" class="custom-select">
          <option value="none">
            <span v-if="fullname">{{ fullname }}</span>
            <span v-else>Aucun</span>
          </option>
          <option :value="company.id" v-for="company in userCompanies" :key="company.id">{{ company.name }} ({{ company.siret }})</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullname: {
      type: String,
      required: false,
      default: ''
    },
    companies: {
      type: String,
      required: false,
      default: ''
    },
    defaultCompany: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => {
    return {
      userCompanies: [],
      selectedCompany: null,
      url: ''
    }
  },

  mounted() {
    this.url =  new URL(window.location.href)

    if (this.url.search.length) {
      const query = new URLSearchParams(this.url.search)

       const queryCompany = query.get('company')

       if (queryCompany) {
        if (queryCompany !== 'none') {
          this.selectedCompany = parseInt(queryCompany)
        } else {
          this.selectedCompany = queryCompany
        }
       } else {
        if (this.defaultCompany) {
          if (this.defaultCompany !== '') {
            this.selectedCompany = parseInt(this.defaultCompany)
          }
        }
       }
    } else {
      if (this.defaultCompany) {
        if (this.defaultCompany !== '') {
          this.selectedCompany = parseInt(this.defaultCompany)

          this.onSelectChange()
        }
      }
    }

    if (this.companies) {
      if (this.companies !== '') {
        this.userCompanies = JSON.parse(this.companies)
      }
    }
  },

  methods: {
    onSelectChange() {
      const params = new URLSearchParams(this.url.search)

      params.set('company', this.selectedCompany)

      this.url.search = params.toString();

      window.location.replace(this.url.toString());
    }
  }
}
</script>
